export class ApiPermissions {
	public static User = {
	    FindUsers: '40e7cd2f-1c52-422a-bd27-cc1db29dcf68',
	    QuickSearch: '225a66cf-397a-4b49-8ba8-59b863fdc5d4',
	    GetUserDetails: '47cbbe1d-4c3e-4466-b44e-ced8b4285280',
	    UpdateUserRealms: '3aa7043c-d985-4665-84df-ba46c33b3759',
	    UpdateUserRoles: 'ac80c139-b1d8-4eeb-b016-862822639852',
	    EditWebsiteProfile: '66f4df68-18f4-4731-82a3-d0416527ad6c',
	    EditWebsitePassword: 'cc24c3ee-7e97-4fb3-a1ce-17939e960f68',
	    EditIngameAccount: 'b9661661-96af-4419-a165-d5f41d4520fc',
	    EditIngameAccountPassword: 'ad640f2c-f910-4643-a189-daa01f8b72df',
	    EditIngameAccountRank: '6edec8ce-1af3-4da4-bf09-7f52cb324504'
	};

	public static Realm = {
	    EditRealmName: '834ec0c3-f379-4eb5-a62f-5c8256c21da1',
	    EditRealmSecurity: 'fdd7ccd6-1075-4abf-bfd1-9ec054d9820d',
	    ExecuteServerScripts: '4faab5ba-8a67-40a7-add9-25c40f85ce2b',
	    RestartRealm: 'd3970c7a-4090-47cc-9a0a-75430252ce84',
	    UploadMaps: '338d8270-d5f2-4fb3-9667-98f54130ca9c',
	    UploadDBC: 'ad2575e8-7a41-4aea-98e4-1fda93cb7853',
	    UploadWoWExe: '2ac4da37-561b-4cfc-b6e5-9648b0a2454b',
	    UploadPatch: '42b477b8-bdd1-46ca-a5c8-7b5d4364f1a4',
	    UploadLua: '42b477c8-adf1-84ca-a5c8-7b5d4364f1a4',
	    GetCoreFiles: '4e825ac3-5245-476e-bfaa-4cc647aac344',
	    Modules: '326d9ed3-1db6-4ca7-ab27-579cd9597e46',
	    WorldServerConfig: 'c06e501e-7840-44c2-b1fa-77e2d1c9a40e'
	};

	public static News = {
	    CreateNews: 'e5235138-4806-4e60-80d1-cda354772312',
	    EditNews: '580cd677-5658-4ebd-ad9f-fa1890893692',
	    DeleteNews: '4223c188-d9e6-49e1-bda0-df24247617ff'
	};

	public static Slider = {
	    Create: 'c440bb0b-5e72-433e-9a5d-073d77c1113c',
	    Edit: '580cd677-5658-4ebd-ad9f-fa1890893692',
	    Delete: '3b68cd36-242a-4765-90d4-75bcf2878bff'
	};

	public static Toast = {
	    Create: '288ca01f-ac2b-48b4-9517-45583e0301d7',
	    Delete: '141c11d6-b3e9-4d2c-8b96-f68cc973c36a'
	};

	public static Changelog = {
	    SaveRelease: '5d9db0af-d60e-46f2-af60-c540db512a4a',
	    DeleteRelease: 'cad73d17-584e-4f4b-b67a-9325f6bbbea1',

	    SaveCategory: '9d8f8c24-fd1e-4520-bcb8-2d390fcaf80e',
	    DeleteCategory: '2bc1651a-5b62-4db3-9274-8ded6255158c',

	    SaveChangelog: 'a93711a8-a0d2-43c9-abad-76f19aced711',
	    DeleteChangelog: '78f0e8a2-3115-411e-90a8-e9ff7e960499'
	};

	public static Content = {
	    CreateContentPage: '0d0a7304-0b87-4212-9930-6c20d45bdc13',
	    DeleteContentPage: '7e95e0c6-ef76-4224-8580-ecfdde524d40',
	    EditContentPage: '90393740-1ffa-4967-8827-0a6b3942eeba'
	};

	public static BugTracker = {
	    CreateCategory: 'abe9d8c0-4199-4912-8aeb-f18c43000033',
	    UpdateIssue: '47afc470-71a9-4e85-9692-eed00b4b83f5'
	}
}
